import './assets/styles/App.css';
import LandingPage from './pages/LandingPage';
import Cadastro from './pages/CadastroPage';
import Dashboard from './pages/DashboardPage';
import IncluirCredito from './pages/IncluirCreditoPage';
import CompanyRegister from './pages/CompanyRegisterPage';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./components/common/PrivateRoute";
import BotaoWhatsApp from './components/common/BotaoWhatsApp';
import { NotificacaoProvider } from "./context/NotificacaoContext";
import { AuthProvider } from './context/AuthContext';
import Footer from "./components/common/Footer";

function App() {
  return (
     <NotificacaoProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={
              <>
                <LandingPage />
                <BotaoWhatsApp />
              </>} />
            <Route path="/cadastro" element={<Cadastro />} />
            <Route path="/company" element={<CompanyRegister />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/incluir-credito"
              element={
                <PrivateRoute>
                  <IncluirCredito />
                </PrivateRoute>
              }
            />
          </Routes>
          <Footer />
        </Router>
      </AuthProvider>
     </NotificacaoProvider>
  );
}

export default App;